import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import useCountryHook from "../../../common/hooks/useCountryList.ts";

export interface SystemSupportAccessLocationsFieldProps {
    supportAccessLocations: Array<string>;
    onChange: (locations: Array<string>) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
}

function SystemSupportAccessLocationsField(props: SystemSupportAccessLocationsFieldProps) {
    const { translateString } = useTranslation();
    const { selectableCountries, countriesIsLoading } = useCountryHook();

    return (
        <DotLegalMultiSelect
            isLoading={countriesIsLoading}
            options={selectableCountries}
            chosenOptions={props.supportAccessLocations}
            onChange={props.readOnly ? () => {} : (countries) => props.onChange(countries)}
            placeholder={translateString("supportAccess")}
            label={translateString("supportAccess")}
            toolTipText={translateString("systemSupportTooltip")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemSupportAccessLocationsField;
